import Cart from "../CartComponents/Cart"; // Yolun doğru olduğundan emin ol
import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import api from "../utils/api";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
function CartPage() {
  const [extraContentList, setExtraContentList] = useState(null);
  const [choiceClass, setChoiceClass] = useState(null);
  const [allExtraById, setAllExtraById] = useState([]);
  const [extraWithStatus, setExtraWithStatus] = useState([]);
  const [activeClassList, setActiveClassList] = useState([]);
  const ClassArray = [
    { value: "class 2", title: "Class 2", status: false },
    { value: "class 3", title: "Class 3", status: false },
    { value: "class 4", title: "Class 4", status: false },
  ];
  const user = JSON.parse(localStorage.getItem("postUser"));

  const userExtraScore = user.extrascore;
  const navigate = useNavigate();
  const acitveClass = useSelector((state) => state.activeComponent.value);
  useEffect(() => {
    const userClassList = user.purchasedPackages;

    if (userClassList && Array.isArray(userClassList)) {
      const lastList = ClassArray.map((item) => {
        // userClassList içindeki objelerin packageId'si ile item.value'yu karşılaştırıyoruz
        const isPurchased = userClassList.some(
          (activePackage) =>
            activePackage.packageId?.toLowerCase() ===
            item.value?.toLowerCase(),
        );

        return {
          ...item,
          status: isPurchased, // Eğer eşleşme varsa true, yoksa false dönecek
        };
      });

      setActiveClassList(lastList);
    }
  }, []); // Bağımlılık dizisine eklemek her zaman daha güvenlidir
  useEffect(() => {
    const fetchExtraContent = async () => {
      let active_name = null;

      if (acitveClass === 1 || choiceClass === "class 2") {
        active_name = "class 2";
      } else if (acitveClass === 2 || choiceClass === "class 3") {
        active_name = "class 3";
      } else if (acitveClass === 3 || choiceClass === "class 4") {
        active_name = "class 4";
      }

      setChoiceClass(active_name);
      if (!active_name) return;

      try {
        const response = await api.get("get_extraScore", {
          params: { class_name: active_name, id: user._id },
        });

        if (response.status === 200) {
          const extraContentValue = response.data.result;
          setExtraContentList(extraContentValue);
        }
      } catch (error) {
        console.error("Veri çekme hatası:", error);
      }
    };

    fetchExtraContent();
  }, [acitveClass, choiceClass]);

  useEffect(() => {
    const getExtraAllById = async () => {
      try {
        const res = await api.get("extra_statisticsById", {
          params: { userId: user._id },
        });
        if (res.status === 200) {
          setAllExtraById(res.data.result);
        }
      } catch (error) {
        console.error("Extra verisi çekme hatası:", error);
      }
    };
    getExtraAllById();
  }, []);

  useEffect(() => {
    if (allExtraById && extraContentList && extraContentList.length > 0) {
      const updatedExtras = extraContentList.map((item) => ({
        ...item,
        status: allExtraById.some(
          (completedItem) => completedItem === item.extra_name,
        ),
      }));

      setExtraContentList(updatedExtras);
    }
  }, [allExtraById]);

  return (
    <div
      className="flex flex-col gap-2 min-h-screen"
      style={{
        fontFamily: "Inter, system-ui, -apple-system, sans-serif ",
      }}
    >
      <div className="container mx-auto px-4 mt-6 ">
        <div
          className="bg-yellow-500 flex flex-row items-center justify-between 
        gap-4 px-6 py-6 rounded-2xl shadow-lg"
        >
          <div className="flex flex-col text-left">
            <h1 className="text-md sm:text-xl font-semibold text-gray-900 mb-1">
              Classroom - Extra Chapters
            </h1>
            <hr className="border border-purple-500" />
            <p className="text-gray-800 text-xs sm:text-base ">
              İlkokul öğrencileri için kapsamlı bir pekiştirme
            </p>
          </div>

          <button
            className="bg-white w-12 h-12 flex items-center justify-center rounded-full
             text-red-600 shadow-md hover:bg-red-50 transition-colors"
            onClick={() => navigate("/HomePage")}
          >
            <X size={24} />
          </button>
        </div>
      </div>
      {!choiceClass ? (
        <div className="ml-4">
          <div
            className="w-[430px] bg-yellow-500 flex flex-col items-center justify-center p-5 
             border-yellow-600 rounded-xl text-white "
          >
            {/* İkon Bölümü */}
            <div
              className="flex h-16 w-16 md:h-20 md:w-20 lg:h-28 lg:w-28 items-center justify-center 
                text-3xl md:text-5xl lg:text-7xl 
                font-semibold rounded-full mb-4 bg-purple-600 p-2"
            >
              🏫
            </div>

            {/* Metin Bölümü */}
            <div className="flex flex-col items-center gap-2">
              {/* İngilizce Metin */}
              <p className="text-lg md:text-xl font-semibold tracking-wide">
                Please select a class to continue
              </p>

              {/* Mor Çizgi */}
              <div className="w-full h-0.5 bg-purple-500 rounded-full my-1"></div>

              {/* Türkçe Metin */}
              <p className="text-base md:text-lg font-medium ">
                Lütfen devam etmek için bir sınıf seçiniz.
              </p>
            </div>
            <div className="flex gap-2 justify-center items-center p-4 ">
              {activeClassList.map((item, index) => (
                <button
                  key={index}
                  onClick={() => setChoiceClass(item.value)}
                  className={` bg-purple-500 w-30 h-12 py-2 px-2 sm:px-4 rounded-xl text-lg
                 font-normal text-white transition-all active:scale-95 ${item.status ? "block" : "hidden"}`}
                >
                  {item.title}
                </button>
              ))}
            </div>
          </div>
        </div>
      ) : (
        <div className="container mx-auto px-4 py-8">
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4  xl:grid-cols-6 gap-6">
            {extraContentList &&
              extraContentList.map((lesson, index) => (
                <Cart key={index} lesson={lesson} />
              ))}
          </div>
        </div>
      )}
    </div>
  );
}

export default CartPage;
